import { render, staticRenderFns } from "./VehicleTypeListTable.vue?vue&type=template&id=2ac956a8"
import script from "./VehicleTypeListTable.vue?vue&type=script&lang=js"
export * from "./VehicleTypeListTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports